import styled from "styled-components";

import { spacing } from "@runwayhealth/runway-components-react";

const PageConsultationFooter = styled.div`
  position: relative;
`;

export default PageConsultationFooter;
